module.exports = __webpack_public_path__ + "img/img_Colleges18.ef54ce73.jpg";